// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const mediaQueries = {
    sm: "320px",
    md: "600px",
    lg: "840px",
    xl: "1280px",
};
module.exports = mediaQueries;
//# sourceMappingURL=mediaQueries.js.map